import { render, staticRenderFns } from "./sDataInsuredEdit.vue?vue&type=template&id=658095ac"
import script from "./sDataInsuredEdit.vue?vue&type=script&lang=js"
export * from "./sDataInsuredEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports